import { Button, Code, Clipboard } from "@chakra-ui/react";
import { Tooltip } from "../ui/tooltip";
import useThemeColors from "../../hooks/useThemeColors";

interface Props {
  value: string;
}

function CustomCode({ value }: Props) {
  const colors = useThemeColors();
  return (
    <Code fontSize="xs" color={colors.text.tertiary} pr={0}>
      {value}
      <Clipboard.Root value={value}>
        <Tooltip content="Copy to clipboard">
          <Button
            size="2xs"
            variant="ghost"
            onClick={(e) => e.stopPropagation()}
            colorPalette={colors.schoolAccent.primary}
          >
            <Clipboard.Trigger asChild>
              <Clipboard.Indicator />
            </Clipboard.Trigger>
          </Button>
        </Tooltip>
      </Clipboard.Root>
    </Code>
  );
}

export default CustomCode;
